import { apiFetch } from '@/lib/api';

export type ReportRange = {
  /** Inclusive `yyyy-MM-dd` bounds; omit for "all time". */
  from?: string;
  to?: string;
};

export type CategoryReportRow = {
  categoryId: string | null;
  name: string;
  icon: string;
  color: string;
  totalMinor: number;
  expenseCount: number;
};

export type MemberReportRow = {
  memberId: string;
  name: string;
  paidMinor: number;
  shareMinor: number;
  expenseCount: number;
};

export type MonthReportRow = {
  /** `yyyy-MM`. */
  monthKey: string;
  totalMinor: number;
  expenseCount: number;
};

function buildRangeParams(range: ReportRange): string {
  const params = new URLSearchParams();
  if (range.from) {
    params.append('from', range.from);
  }
  if (range.to) {
    params.append('to', range.to);
  }
  const qs = params.toString();
  return qs ? `?${qs}` : '';
}

export async function reportByCategory(
  groupId: string,
  range: ReportRange = {}
): Promise<CategoryReportRow[]> {
  const qs = buildRangeParams(range);
  return apiFetch<CategoryReportRow[]>(`/groups/${groupId}/reports/category${qs}`);
}

export async function reportByMember(
  groupId: string,
  range: ReportRange = {}
): Promise<MemberReportRow[]> {
  const qs = buildRangeParams(range);
  return apiFetch<MemberReportRow[]>(`/groups/${groupId}/reports/member${qs}`);
}

export async function reportByMonth(
  groupId: string,
  range: ReportRange = {}
): Promise<MonthReportRow[]> {
  const qs = buildRangeParams(range);
  return apiFetch<MonthReportRow[]>(`/groups/${groupId}/reports/month${qs}`);
}
